/* eslint-disable react-hooks/exhaustive-deps */
import Logo from '../../../assets/images/logo.svg';
import MyGov from '../../../assets/images/MyGov.png';
import GovOfIndia from '../../../assets/images/GovOfIndia.svg';
import { dataActions } from '../../../shared/store/dataSlice';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Call, FacebookIcon, InstaIcon, LastUpdated, LinkedInIcon, Print, TwitterIcon, VisitorNo } from '../svg/AllSvg';
import moment from 'moment';
import { url } from '../../../shared/utils/url';
import useAxios from '../../../shared/hooks/use-axios';

const Footer = () => {
  const lang: string = useSelector((state: any) => state.ui.lang);
  const [footerMenuData, setFooterMenuData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  let [data, setData] = useState<any>(null)
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleNavigate = async (menu: any) => {
    navigate(`${(menu?.url?.replace(`/en/`, ""))}`)
  }

  const handleLink = (item: any) => {
    dispatch(dataActions.setWebOpen(true));
    dispatch(dataActions.setLink(item));
  }

  const visitorCountUpdate = async () => {
    try {
      const res: any = await useAxios.post(`${url?.visitors_count_update}`, { counter: !!!localStorage.getItem("visitor_count") ? 1 : 0 });

      if (res && res?.status === 200) {
        localStorage.setItem("visitor_count", "1")
        visitorCount()
      }
    } catch (error) {
      console.error("error while visitor count update", error);
    }
  };

  const visitorCount = async () => {
    try {
      const res: any = await useAxios.get(url.visitors_count);

      if (res && res.status === 200) {
        data = { ...data, visitors_count: res?.data?.results?.visitors_count };
        setData(data);
      }
    } catch (error) {
      console.error("error while fetching visitor count", error);
    }
  }

  const lastUpdatedDate = async () => {
    try {
      const res: any = await useAxios.get(url.last_updated_date);

      if (res && res.status === 200) {
        data = { ...data, last_updated_date: res?.data?.results?.last_updated_date };
        setData(data);
      }
    } catch (error) {
      console.error("error while fetching last updated date", error);
    }
  }

  useEffect(() => {
    visitorCount();
    visitorCountUpdate();
    lastUpdatedDate();
  }, [])

  const getFooterMenu = async () => {
    try {
      setLoading(true)
      const res: any = await useAxios.get(`/en${url?.menus}footer-menu/`);

      if (res && res?.status === 200) {
        setFooterMenuData(res?.data)
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      console.error("error while feching footer menu", error);
    }
  };

  useEffect(() => {
    getFooterMenu();
  }, [])

  return (
    <div id="footer" className="bg-[#2A2B2D] dark:bg-[#191919] w-full h-full flex flex-col relative">
      <img src={require('../../../assets/images/footer-bg.png')} alt="footer-bg" className='absolute left-0 right-0 bottom-0 top-0 w-full h-full object-cover' />
      <div className="w-full container 1.5xl:max-w-[1450px] flex flex-col pb-[20px] lg:pb-[38px] pt-[30px] lg:pt-[50px] relative z-[1]">
        <div className="w-full h-full flex justify-between gap-[25px] lg:flex-row flex-col">
          <div className="flex flex-col xsm:flex-row gap-[20px] xl:gap-[25px] lg:flex-col lg:w-auto w-full lg:justify-start justify-start xsm:justify-between">
            <div className='flex flex-col gap-[20px] xl:gap-[25px]'>
              <Link aria-label={`${lang === "en" ? "Northern Coalfields Limited" : "नॉर्दर्न कोलफील्ड्स लिमिटेड"}`} title={`${lang === "en" ? "Northern Coalfields Limited" : "नॉर्दर्न कोलफील्ड्स लिमिटेड"}`} to='/' className="hover:shadow-[0_0_0_2px_rgba(255,255,255,0.2)] focus:shadow-[0_0_0_2px_rgba(255,255,255,0.2)] rounded-[2px] min-w-[117px] w-[117px]">
                <img src={Logo} alt={`${lang === "en" ? "Northern Coalfields Limited" : "नॉर्दर्न कोलफील्ड्स लिमिटेड"}`} className="w-[117px] h-[49px]" />
              </Link>

              <div className='flex flex-col gap-[15px] xlx:gap-[25px]'>
                <h6 className='text-white font-medium max-w-[240px]' tabIndex={0}>{t("footer.address")}</h6>

                <div className='flex flex-col gap-[8px]'>
                  <a href="tel:07805266670" className='flex items-center gap-[8px] text-white font-medium text-sm focus:underline hover:underline'><Call /> 07805-266670</a>
                  <a href="tel:07805266640" className='flex items-center gap-[8px] text-white font-medium text-sm focus:underline hover:underline'><Print /> 07805-266640</a>
                </div>

                <div className="flex items-center gap-[6px] ml-[-8px]">
                  <Link to="https://x.com/NCL_SINGRAULI" target="_blank" aria-label="Visit Twitter Page" title='Twitter' className="min-w-[33px] h-[33px] flex items-center justify-center rounded-full hover:shadow-[0px_14px_64px_rgba(24,39,75,0.12),0px_8px_22px_rgba(24,39,75,0.12)] focus:shadow-[0px_14px_64px_rgba(24,39,75,0.12),0px_8px_22px_rgba(24,39,75,0.12)] hover:bg-black focus:bg-black" onClick={(e) => { handleLink("https://x.com/NCL_SINGRAULI"); e.preventDefault(); }}><TwitterIcon className="fill-white" /></Link>
                  <Link to="https://www.facebook.com/northerncoalfields" target="_blank" aria-label="Visit Facebook Page" title='Facebook' className="min-w-[33px] h-[33px] flex items-center justify-center rounded-full hover:bg-[#4267B2] focus:bg-[#4267B2]" onClick={(e) => { handleLink("https://www.facebook.com/northerncoalfields"); e.preventDefault(); }}><FacebookIcon className="fill-white" /></Link>
                  <Link to="https://www.instagram.com/ncl_singrauli" target="_blank" aria-label="Visit Instagram Page" title='Instagram' className="min-w-[33px] h-[33px] flex items-center justify-center rounded-full hover:shadow-[0px_14px_64px_rgba(24,39,75,0.12),0px_8px_22px_rgba(24,39,75,0.12)] focus:shadow-[0px_14px_64px_rgba(24,39,75,0.12),0px_8px_22px_rgba(24,39,75,0.12)] instagram-icon" onClick={(e) => { handleLink("https://www.instagram.com/ncl_singrauli"); e.preventDefault(); }}><InstaIcon className="fill-white" /></Link>
                  <Link to="https://in.linkedin.com/company/northerncoalfields" target="_blank" aria-label="Visit LinkedIn Page" title='LinkedIn' className="min-w-[33px] h-[33px] flex items-center justify-center rounded-full hover:bg-[#0A66C2] focus:bg-[#0A66C2]" onClick={(e) => { handleLink("https://in.linkedin.com/company/northerncoalfields"); e.preventDefault(); }}><LinkedInIcon className="fill-white" /></Link>
                </div>
              </div>
            </div>

            <div className="flex items-center gap-[14px] lg:pt-[25px] h-fit">
              <Link to="https://www.mygov.in/" target="_blank" onClick={(e) => { handleLink("https://www.mygov.in/"); e.preventDefault(); }} className="border border-transparent  hover:border-[#E5E5E5] hover:rounded-[6px] focus:border-[#E5E5E5] dark:hover:border-[#40434D] dark:focus:border-[#40434D] focus:rounded-[6px] p-[6px]" aria-label="My Government" title="My Government"><img src={MyGov} alt="My Government" /></Link>
              <Link to="https://www.india.gov.in/" target="_blank" onClick={(e) => { handleLink("https://www.india.gov.in/"); e.preventDefault(); }} className="border border-transparent  hover:border-[#E5E5E5] hover:rounded-[6px] focus:border-[#E5E5E5] dark:hover:border-[#40434D] dark:focus:border-[#40434D] focus:rounded-[6px] p-[6px]" aria-label="Bharat Sarkar" title="Bharat Sarkar"><img src={GovOfIndia} alt="Bharat Sarkar" className="footer-icon" /></Link>
            </div>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-4 gap-y-[20px] gap-x-[20px]">
            {loading ?
              <>
                {Array.isArray([1, 2, 3, 4]) && [1, 2, 3, 4]?.map((item: any, index: number) => (
                  <div className="flex flex-col gap-[25px] animate-pulse" key={index}>
                    <div className="w-[100px] h-[12px] rounded-full bg-bgDarkDull"></div>

                    {Array.isArray([1, 2, 3, 4, 5, 6]) && [1, 2, 3, 4, 5, 6]?.map((item: any, index: number) => (
                      <div className="max-w-[185px] mms:w-[185px] h-[12px] rounded-full bg-bgDarkDull" key={index}></div>
                    ))}
                  </div>
                ))}
              </>
              : <>
                {Array.isArray(footerMenuData) && footerMenuData?.map((item: any, index: number) => (
                  <div className="flex flex-col gap-[15px]" key={index}>
                    <h5 className="text-white font-semibold pb-[8px]">{item?.title}</h5>

                    {Array.isArray(item?.subRoutes) && item?.subRoutes?.map((i: any, idx: number) => (
                      <React.Fragment key={idx}>
                        {
                          i?.open_in_new_tab ?
                            <Link to={i?.url?.replace(`/en/`, "")} target='_blank' className="text-white text-opacity-[0.6] text-base font-normal hover:underline focus:underline w-fit" onClick={(e) => { if (i?.url_type === "external") { handleLink(i?.url?.replace(`/en/`, "")); e.preventDefault(); } }}><h5>{i?.title}</h5></Link>
                            : <Link to={i?.url?.replace(`/en/`, "")} className="text-white text-opacity-[0.6] text-base font-normal hover:underline focus:underline w-fit" onClick={() => handleNavigate(i)}><h5>{i?.title}</h5></Link>
                        }
                      </React.Fragment>
                    ))}
                  </div>
                ))}
              </>}
          </div>
        </div>
      </div>

      <div className="border-t border-[#E7E9ED] border-opacity-[0.2] px-[15px] sm:px-[40px] xl:px-[80px] py-[10px] xlx:py-[15px] w-full flex items-center xlsm:justify-between gap-[10px] xlsm:gap-[15px] xl:gap-[18px] xlsm:flex-row flex-col relative z-[1]">
        <p className="text-white font-medium">© {new Date().getFullYear()} {t("footer.nclcil")} {t("footer.all_rights")}</p>

        <div className='flex items-center gap-[10px] mm:gap-[15px] xl:gap-[18px]'>
          <div className="flex items-center gap-[8px]">
            <LastUpdated className="min-w-[15px] w-[15px] h-[15px] fill-white" />

            <p className="uppercase text-white font-medium">{t("footer.last_updated")} : {!!data?.last_updated_date ? moment(data?.last_updated_date).format('MMM DD, YYYY') : "-"}</p>
          </div>

          <div className="flex items-center gap-[8px]">
            <VisitorNo className="min-w-[17px] w-[17px] h-[17px] fill-white" />

            <p className="uppercase text-white font-medium">{t("footer.visitor_no")} {!!data?.visitors_count ? data?.visitors_count : "-"}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;